import api from './api';
import { News, ApiResponse, NewsType } from '../types';

const newsService = {
  getAllNews: async (page = 1, limit = 20): Promise<ApiResponse<News[]>> => {
    try {
      const response = await api.get<ApiResponse<News[]>>(`/news?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLatestNews: async (page = 1, limit = 10): Promise<ApiResponse<News[]>> => {
    try {
      const response = await api.get<ApiResponse<News[]>>(`/news/latest?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getNewsByTeam: async (teamId: number): Promise<News[]> => {
    try {
      const response = await api.get<News[]>(`/news/team/${teamId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getNewsByLeague: async (leagueId: number): Promise<News[]> => {
    try {
      const response = await api.get<News[]>(`/news/league/${leagueId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPopularNews: async (): Promise<News[]> => {
    try {
      const response = await api.get<News[]>('/news/popular');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getNewsByDateRange: async (startDate: string, endDate: string): Promise<News[]> => {
    try {
      const response = await api.get<News[]>(`/news/date-range?start=${startDate}&end=${endDate}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  searchNews: async (query: string): Promise<News[]> => {
    try {
      const response = await api.get<News[]>(`/news/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getNewsByType: async (type: NewsType, page = 1, limit = 10): Promise<ApiResponse<News[]>> => {
    try {
      const response = await api.get<ApiResponse<News[]>>(`/news/type/${type}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default newsService; 